<template>
  <div>
    <excise-transactions listObject="tank" :objectId="tankId"
                          :activityTypes="[{text:'All',value:''},{divider:true},
                                            {text:'Opening inventory',value:'ExciseVesselTransactionInitial'},
                                            {text:'Distillation',value:'Distillation'},
                                            {text:'Blending',value:'Blend'},
                                            {text:'Bottling',value:'Bottling'},
                                            {text:'Proof',value:'TankTransactionProof'},
                                            {text:'Fill casks',value:'TankTransactionFillCask'},
                                            {text:'Reduce inventory',value:'ExciseVesselTransactionReduceInventory'},
                                            {text:'Transfer to tank',value:'ExciseVesselTransactionTransferToTank'},
                                            {text:'Transfer from cask',value:'ExciseVesselTransactionTransferToTank'},
                                            {text:'Transfer to bulk container',value:'ExciseVesselTransactionTransferToBulkContainer'},
                                            {text:'Transfer from bulk container',value:'ExciseVesselTransactionTransferToTank'},
                                            {text:'Denature',value:'ExciseVesselTransactionDenature'},
                                            {text:'Returned from product',value:'ProductReturnToTank'},
                                            {text:'Unpacked',value:'ProductUnpacked'},
                                            ]"
                          :back="[{text:'Tanks',to:{name:'EquipmentTanks'}}]"
                          :vessel="false"/>
  </div>
</template>

<script>
import ExciseTransactions from '@/components/ExciseTransactions'

export default {
  name: 'EquipmentTanksTransactions',
  components: {ExciseTransactions},
  props: {
    tankId: {type:String, required:true}
  }
}
</script>